export const apiUrl = process.env.REACT_APP_URL_API

// Check if running in local environment (localhost or 127.0.0.1)
export const isLocalEnvironment =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

// Cookie security settings based on environment
export const cookieOptions = {
  path: '/',
  secure: !isLocalEnvironment, // Only use secure cookies in staging/production
  sameSite: 'strict' as const,
}

// API Error Messages
export const PHONE_VERIFICATION_REQUIRED_MESSAGE =
  'Phone verification required. Please verify your phone number before logging in.'
